import {Localizer} from "../../../infrastructure/localization/localizer";

export enum VejledersamtaleStatusEnum {
    Planlagt = 1,
    Klarmeldt = 2,
    Afholdt = 3,
    OverskredetFrist = 4,
    EndnuIkkePlanlagt = 5
}

export function GetStatusString(status: VejledersamtaleStatusEnum): string {
    switch (status) {
        case VejledersamtaleStatusEnum.Planlagt:
            return Localizer.global_planlagt();
        case VejledersamtaleStatusEnum.Klarmeldt:
            return Localizer.global_klarmeldt();
        case VejledersamtaleStatusEnum.Afholdt:
            return Localizer.global_afholdt();
        case VejledersamtaleStatusEnum.OverskredetFrist:
            return Localizer.global_overskredetFrist();
        case VejledersamtaleStatusEnum.EndnuIkkePlanlagt:
            return Localizer.global_endnuIkkePlanlagt();
        default:
            return "";
    }
}
